import { render, staticRenderFns } from "./r-divider.vue?vue&type=template&id=79aa03d6&scoped=true"
import script from "./r-divider.vue?vue&type=script&lang=js"
export * from "./r-divider.vue?vue&type=script&lang=js"
import style0 from "./r-divider.vue?vue&type=style&index=0&id=79aa03d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aa03d6",
  null
  
)

export default component.exports